import { ChangeDetectionStrategy, Component, model } from '@angular/core';
import { UiSelectComponent, UiSelectOption } from './select.component';

const MONTH_OPTIONS: UiSelectOption[] = [
  { id: 1,  label: 'Enero' },
  { id: 2,  label: 'Febrero' },
  { id: 3,  label: 'Marzo' },
  { id: 4,  label: 'Abril' },
  { id: 5,  label: 'Mayo' },
  { id: 6,  label: 'Junio' },
  { id: 7,  label: 'Julio' },
  { id: 8,  label: 'Agosto' },
  { id: 9,  label: 'Septiembre' },
  { id: 10, label: 'Octubre' },
  { id: 11, label: 'Noviembre' },
  { id: 12, label: 'Diciembre' },
];

/**
 * Variante de ui-select pre-configurada para selección de mes.
 * Opciones fijas: Enero – Diciembre.
 * Uso: <ui-month-select [(selected)]="selectedMonth" />
 */
@Component({
  selector: 'ui-month-select',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UiSelectComponent],
  template: `
    <ui-select
      placeholder="Mes"
      [options]="monthOptions"
      [(selected)]="selected"
      [showLabel]="false"
      [showOptionalHint]="false"
      style="width: 160px"
    />
  `,
})
export class UiMonthSelectComponent {
  protected readonly monthOptions = MONTH_OPTIONS;
  readonly selected = model<UiSelectOption | null>(null);
}
